import React from "react";
import PropTypes from "prop-types";

import { useFormikContext } from "formik";

import Input from "components/FormikControl/Input";
import ButtonInput from "components/FormikControl/Input/ButtonInput"
import SearchableSelect from "components/FormikControl/SearchableSelect";
import Select from "components/FormikControl/Select";
import DatePicker from "components/FormikControl/DatePicker";
import TimePicker from "components/FormikControl/TimePicker";
import Button from "components/FormikControl/Button";
import ClearButton from "components/FormikControl/Button/ClearButton";
import Switch from "components/FormikControl/Switch";
import FileUpload from "components/FormikControl/FileUpload";
import FileDownload from "components/FormikControl/FileDownload";
import MultiSelect from "components/FormikControl/MultiSelect";
import Radio from "./Radio/Radio";
import RenderOnlyField from "components/FormikControl/RenderOnlyField";
import Note from "components/FormikControl/Note";

import Title from "components/FormikControl/Title";
import PhoneField from "./PhoneField";
import ImageRenderField from "./ImageRenderField";
import AudioPlayerField from "./AudioPlayerField";
import MapField from "./MapField";
import RestrictedInput from "./RestrictedInput";
import ReactSelect from "./ReactSelect";
import TabbedDisplay from "./TabbedDisplay";

const FormikControl = (props) => {
  const { control, children, disabledWhen, ...rest } = props;
  const formik = useFormikContext();

  if (disabledWhen) {
    for (const [key, value] of Object.entries(disabledWhen)) {
      if (formik.values[key] === value) {
        rest["disabled"] = true;
      }
    }
  }
  switch (control) {
    case "input":
      return <Input {...rest} />;
      case "ButtonInput":
      return <ButtonInput {...rest} />;
    case "phone":
      return <PhoneField {...rest} />;
    case "select":
      return <SearchableSelect {...rest} />;
    case "nosearchselect":
      return <Select {...rest} />;
    case "datepicker":
      return <DatePicker {...rest} />;
    case "timepicker":
      return <TimePicker {...rest} />;
    case "fileupload":
      return <FileUpload {...rest} />;
    case "filedownload":
      return <FileDownload {...rest} />;  
    case "button":
      return <Button {...rest}>{children}</Button>;
      case "clearbutton":
        return <ClearButton {...rest} />;
    case "switch":
      return <Switch {...rest} />;
    case "multiselect":
      return <MultiSelect {...rest} />;
    case "radio":
      return <Radio {...rest} />;
    case "renderonly":
      return <RenderOnlyField {...rest} />;
    
      case "note":
      return <Note {...rest} />;
    case "title":
      return <Title {...rest} />;
    case "imagerender":
      return <ImageRenderField {...rest} />;
    case "audio":
      return <AudioPlayerField {...rest} />;
    case "mapfield":
      return <MapField {...rest} />;
    case "reactselect":
      return <ReactSelect {...rest} />;
    case "restricted":
      return <RestrictedInput {...rest} />;
    case "tabbeddisplay":
      return <TabbedDisplay {...rest} />;
    default:
      return null;
  }
};
FormikControl.propTypes = {
  control: PropTypes.string,
  children: PropTypes.func,
  disabledWhen: PropTypes.object,
};

export default FormikControl;
